import { useI18n } from 'vue-i18n';
import type { LocalizedFieldDto } from '@carvia/ros-client-types';
import { getLocalizedField } from '@/utils/get-localized-field';

export const useLocalizedFields = () => {
  const { locale } = useI18n();
  const getLocalizedFieldForLocale = (field: LocalizedFieldDto | null | undefined) =>
    getLocalizedField(field, locale.value);
  return { getLocalizedField: getLocalizedFieldForLocale };
};
